export enum HlsJsStreamControllerState {
	FRAG_LOADING = 'FRAG_LOADING',
	IDLE = 'IDLE',
	PARSED = 'PARSED',
	STOPPED = 'STOPPED'
}
